class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector("[data-trigger]");
    this.template = this.querySelector("[data-template]");
  }

  connectedCallback() {
    this.trigger?.addEventListener("click", this.handleClick);
  }

  handleClick = () => {
    const html = this.template.innerHTML;

    this.trigger.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: { html, target: "size-guide-modal" },
      }),
    );
  };
}

if (!customElements.get("size-guide")) {
  customElements.define("size-guide", SizeGuide);
}
